import {Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'comprehensive-system',
    templateUrl: './comprehensive-system.component.html',
    styleUrls: ['./comprehensive-system.component.scss']
})
export class ComprehensiveSystemComponent implements OnInit {

    @Input() heading: string = 'Comprehensive System';
    @Input() slogan: string = 'Large Properties, Large Businesses, Developments';
    @Input() headerCssClass: string = 'p-3';

    @Input() showImage: boolean = true;
    @Input() showHeading: boolean = false;
    @Input() showEmpty: boolean = true;

    constructor() {
    }

    ngOnInit(): void {
    }
}
